import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import { ThemeProvider } from "@mui/material";
import theme from "./theme/theme";

import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <App />
      <Toaster position="top-center" reverseOrder={false} />
    </ThemeProvider>
  </BrowserRouter>
);
